// eslint-disable-next-line no-restricted-imports
import { logEvent as uiLogEvent } from 'fitify-ui/src/utils/analytics'
import { isDefined } from 'fitify-utils/src/properties'

import type { Route } from '../types/routeTypes'

import { getRouteEventName } from './routes'

type ParamValue = boolean | number | string
type AdditionalParams = {
  funnel_id?: string | (() => string | undefined)
}

let additionalParams: AdditionalParams = {}

export const setAdditionalParams = (params: AdditionalParams) => {
  additionalParams = { ...additionalParams, ...params }
}

const resolveParams = (params: AdditionalParams): Record<string, string> =>
  Object.entries(params).reduce<Record<string, string>>((acc, [key, value]) => {
    if (isDefined(value)) {
      const resolvedValue = typeof value === 'function' ? value() : value
      if (resolvedValue) {
        return { ...acc, [key]: resolvedValue }
      }
    }

    return acc
  }, {})

export const logEvent = (
  eventName: string,
  params?: Record<string, unknown>
) => {
  uiLogEvent(eventName, {
    ...resolveParams(additionalParams),
    ...(params || {}),
  })
}

const transformEventParams = (
  params: ParamValue | Record<string, ParamValue>,
  eventKey: string
) => {
  if (typeof params === 'object') {
    return params
  }
  return { [eventKey]: params }
}

const transformArrayParams = (
  params: ParamValue[],
  value: ParamValue[],
  eventKey: string
) => {
  return params.reduce<Record<string, ParamValue>>((acc, curr) => {
    return {
      ...acc,
      [`${eventKey}_${curr}`]: value.includes(curr),
    }
  }, {})
}

export const logEventNameAnswerEvent = (
  eventName: string,
  params: ParamValue | Record<string, ParamValue>
): void => {
  const transformedParams = transformEventParams(params, eventName)
  logEvent(`${eventName}_answer`, transformedParams)
}

export const logAnswerEvent = (
  page: Route<string> | undefined,
  params: ParamValue | Record<string, ParamValue>
): void => {
  const eventName = page && getRouteEventName(page.id)
  if (!eventName || !page.stateKey) {
    return
  }

  const transformedParams = transformEventParams(params, page.stateKey)
  logEvent(`${eventName}_answer`, transformedParams)
}

export const logArrayAnswerEvent = (
  page: Route<string> | undefined,
  params: ParamValue[],
  value: ParamValue[]
) => {
  if (!page || !page.id || !page.stateKey) {
    return
  }

  const transformedParams = transformArrayParams(params, value, page.stateKey)

  logAnswerEvent(page, transformedParams)
}
